exports.list = {
    path: '/invoice',
    name: 'invoice_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/invoice/List.vue"),
}
exports.show = {
    path: '/invoice/show/:id',
    name: 'invoice_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/invoice/Show.vue"),
}